module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "list_demo"
    }
  }, [_c('banner-back', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "icon-uep icon-uep-back button",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  }, [_vm._v("\n    Retour\n  ")]), _vm._v(" "), _c('keep-alive', [_c('demo', {
    staticClass: "md-transparent",
    attrs: {
      "type": _vm.type,
      "plugin": _vm.plugin
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6edf2955!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DemoItem.vue
// module id = 163
// module chunks = 1